<template>
  <div>
    <el-radio-group :disabled="globalDisabled" v-model="goal" @change="$emit('change', goal)">
      <el-radio-button v-if="!deep" ghost :label="OPT_GOAL.APP_ACTIVATE" :disabled="activateDisabled">激活 </el-radio-button>
      <el-radio-button ghost :label="OPT_GOAL.FIRST_PURCHASE" :disabled="firstPurchaseDisabled"> 首次付费 </el-radio-button>
      <el-radio-button ghost :label="OPT_GOAL.APP_PURCHASE" :disabled="appPurchaseDisabled">付费次数 </el-radio-button>
      <el-radio-button ghost :label="OPT_GOAL.APP_REGISTER" :disabled="registerDisabled">注册 </el-radio-button>

      <slot name="backflow"></slot>

      <el-radio-button ghost :label="OPT_GOAL.ONE_DAY_RETENTION" :disabled="oneDayRetentionDisabled"> 次日留存 </el-radio-button>

      <slot name="reserve"></slot>
    </el-radio-group>

    <div style="margin-top: 10px; font-size: 12px" v-if="goal === OPT_GOAL.APP_PURCHASE">
      <span class="g-error-text">请确认是否开通白名单，否则创建时会报错</span>
    </div>
  </div>
</template>
<script>
import BUDGET_CONST from '@/views/create/gdt/model/budget/budget-const.js'
import { WECHAT_SITES } from '@/views/create/gdt/model/siteset/siteset-const.js'
import { PLATFORM, MARKETING_SUB_GOAL } from '@/views/create/gdt/model/project-const.js'

export default {
  props: {
    value: {
      type: String
    },
    globalDisabled: {
      type: Boolean,
      default: false
    },
    //  一条广告的优化目标和深度优化目标不能相同 https://developers.e.qq.com/docs/guide/ads/deep_optimization
    // 传入优化目标或深度优化目标
    positiveGoal: {
      type: String
    },
    planForm: {
      type: Object
    },
    deep: {
      type: Boolean
    }
  },
  data() {
    return {
      ...BUDGET_CONST
    }
  },
  watch: {
    'planForm.marketing_sub_goal'(val, prevVal) {
      // 如果推广目的的子目的从小游戏的回流触达变成其他的，优化目标切换到首次付费（它比较通用，不需要太多的判断）
      if (prevVal === this.MARKETING_SUB_GOAL.RETURN_CUSTOMER_ENGAGEMENT) {
        this.goal = BUDGET_CONST.OPT_GOAL.FIRST_PURCHASE
      }
    }
  },
  computed: {
    goal: {
      get() {
        return this.value
      },
      set(goal) {
        this.$emit('input', goal)
      }
    },
    MARKETING_SUB_GOAL() {
      return MARKETING_SUB_GOAL
    },

    isMiniProgram() {
      return this.planForm.ch_platform_id === PLATFORM.MINIGAME
    },
    // hasWechat() {
    //   return this.planForm.siteSet.some((site) => WECHAT_SITES.includes(site))
    // },
    activateDisabled() {
      return this.isMiniProgram
    },
    // 下单禁用条件
    orderDisabled() {
      if (this.deep && this.positiveGoal === BUDGET_CONST.OPT_GOAL.ECOMMERCE_ORDER) return true
      if (this.isMiniProgram) return true
      return false
    },
    // 首次付费禁用条件
    firstPurchaseDisabled() {
      return this.deep && this.positiveGoal === BUDGET_CONST.OPT_GOAL.FIRST_PURCHASE
    },
    // 付费次数禁用条件
    appPurchaseDisabled() {
      if (this.deep && this.positiveGoal === BUDGET_CONST.OPT_GOAL.APP_PURCHASE) return true
      if (this.deep && this.isMiniProgram) return true
      return false
    },
    registerDisabled() {
      return this.deep && this.positiveGoal === BUDGET_CONST.OPT_GOAL.APP_REGISTER
    },
    backFlowDisabled() {
      if (this.deep) return true
      return this.deep && this.positiveGoal === BUDGET_CONST.OPT_GOAL.BACK_FLOW
    },
    oneDayRetentionDisabled() {
      if (this.deep && this.positiveGoal === BUDGET_CONST.OPT_GOAL.ONE_DAY_RETENTION) return true
      if (this.isMiniProgram) return true

      // 优化目标禁用次日留存，深度优化目标不禁用
      // if (!this.deep && this.hasWechat) return true
      if (!this.deep) return true
      return false
    }
  }
}
</script>
<style lang="scss" scoped></style>
